document.addEventListener('DOMContentLoaded', () => handleFeaturedCollectionsByBranch());

// eslint-disable-next-line complexity
async function handleFeaturedCollectionsByBranch(event, collectionHandle) {
  try {
    const section = document.querySelector('.boa-featured-collections-filter-by-branch');
    if (!section) {
      return;
    }

    const sectionWrapper = section.closest('[id^="featured-collections-filter-by-branch-"]');
    const sectionId = sectionWrapper?.id.replace('featured-collections-filter-by-branch-', '');
    if (!sectionId) {
      return;
    }

    // Master/sub filter in Liquid — never re-fetch the block handle (that returns an empty grid and wipes it).
    if (section.dataset.branchFilterViaLiquid === 'true') {
      if (event) {
        await refreshFilteredSection(section, sectionId);
      }
      return;
    }

    let currentCollectionHandle = collectionHandle;
    if (!collectionHandle) {
      currentCollectionHandle = section.querySelector('.featured-collections [data-collection-handle]')?.dataset.collectionHandle;
    }
    if (!currentCollectionHandle) {
      return;
    }

    const metaobjectId = event?.detail?.cart?.attributes.branch_metaobject_id || section.querySelector('.featured-collections [data-metaobject-id]')?.dataset.metaobjectId;
    const metaobjectGid = metaobjectId ? `gid://shopify/Metaobject/${metaobjectId}` : null;

    const collectionGridElement = section.querySelector(`#featured-collections-grid-${sectionId}`);
    collectionGridElement.style.opacity = 0;

    const htmlResponse = await getNewCollectionContent(sectionId, metaobjectGid, currentCollectionHandle);

    const doc = new DOMParser().parseFromString(htmlResponse, 'text/html');
    const collectionFiltered = doc.querySelector('.boa-featured-collections-filter-by-branch');
    if (!collectionFiltered) {
      return;
    }
    const newSectionElement = collectionFiltered.querySelector(`#featured-collections-grid-${sectionId}`);

    newSectionElement.classList.remove('hidden');
    collectionGridElement.replaceWith(newSectionElement);
    collectionGridElement.style.opacity = 1;

    // Show the product-list (and its button) for the current collection; hide the others
    syncVisibleTabToCollection(section, newSectionElement, currentCollectionHandle);

    // first time loading the page, add event listener to tabs-nav
    if (!collectionHandle) {
      section.querySelector('.tabs-nav__item-list')?.addEventListener('click', handleTabsNavClick);
    }
  } catch (e) {
    console.error('error in handleFeaturedCollectionsByBranch:', e);
  }
}

// Re-render the current page (Liquid self-filters from the updated cart) — no filter param needed.
async function refreshFilteredSection(section, sectionId) {
  const grid = section.querySelector(`#featured-collections-grid-${sectionId}`);
  if (!grid) {
    return;
  }
  try {
    const response = await fetch(`${window.location.pathname}?sections=${sectionId}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      return;
    }
    const data = await response.json();
    const html = data[sectionId];
    if (!html) {
      return;
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newGrid = doc.querySelector(`#featured-collections-grid-${sectionId}`);
    if (!newGrid) {
      return;
    }
    grid.animate({ opacity: [1, 0] }, { duration: 250, easing: 'ease' }).onfinish = () => {
      grid.replaceWith(newGrid);
      newGrid.animate({ opacity: [0, 1] }, { duration: 250, easing: 'ease' });
      syncActiveTabPanel(section, newGrid);
    };
  } catch (e) {
    console.error('error refreshing featured collections by branch:', e);
  }
}

// Tab buttons live outside the swapped grid, so re-apply the active one to the fresh product-lists.
function syncActiveTabPanel(section, grid) {
  const activeId = section.querySelector('.tabs-nav__item[aria-controls][aria-expanded="true"]')?.getAttribute('aria-controls');
  if (!activeId) {
    return;
  }
  grid.querySelectorAll('product-list[id]').forEach((list) => {
    list.hidden = list.id !== activeId;
  });
}

async function getNewCollectionContent(sectionId, metaobjectGid, collectionHandle) {
  let filter = '';
  if (metaobjectGid) {
    filter = `&filter.p.m.boa_ideas.available_in_branches=${metaobjectGid}`;
  }
  const language = window.themeVariables?.routes?.rootUrl !== '/' ? window.themeVariables?.routes?.rootUrl : '';
  const url = `${language}/collections/${encodeURIComponent(collectionHandle)}?sections=${sectionId}${filter}`;
  const response = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Section render request failed: ${response.status}`);
  }

  const data = await response.json();
  const html = data[sectionId];

  if (!html) {
    throw new Error(`No HTML returned for section "${sectionId}"`);
  }
  return html;
}

function syncVisibleTabToCollection(sectionElement, gridElement, collectionHandle) {
  const productLists = gridElement.querySelectorAll('product-list[data-collection-handle]');
  productLists.forEach((list) => {
    const handle = list.dataset.collectionHandle;
    list.hidden = handle !== collectionHandle;
  });

  const tabButtons = sectionElement.querySelectorAll('.tabs-nav__item[data-collection-handle]');
  tabButtons.forEach((btn) => {
    btn.setAttribute('aria-expanded', btn.dataset.collectionHandle === collectionHandle ? 'true' : 'false');
  });
}

function handleTabsNavClick(event) {
  const target = event.target;
  if (target.tagName !== 'BUTTON') {
    return;
  }
  const collectionHandle = target.dataset.collectionHandle;
  handleFeaturedCollectionsByBranch(event, collectionHandle);
}

window.handleFeaturedCollectionsByBranch = handleFeaturedCollectionsByBranch;
